import { render, staticRenderFns } from "./lowRiskDialog.vue?vue&type=template&id=ae424d44"
import script from "./lowRiskDialog.vue?vue&type=script&lang=js"
export * from "./lowRiskDialog.vue?vue&type=script&lang=js"
import style0 from "./lowRiskDialog.vue?vue&type=style&index=0&id=ae424d44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports